<template>
	<div class="row" id="result" v-show="display">
        <div class="row" id="bilanTableHeader">
            <span>Chiffre d'affaire facturé</span>
            <span class="pull-right data-display" :data-value="formattedInfos.catotal">{{formattedInfos.catotal}}</span>
            <sup>€</sup>
        </div>
        <div class="row" id="bilanTable">
            <div class="col-md-6 col-xs-12 col-sm-12 profit">
                <div class="row">
                    <span>Gains structure</span>
                    <span class="pull-right data-display" :data-value="formattedInfos.gains">{{formattedInfos.gains}}</span>
                    <sup>€</sup>
                </div>
            </div>
            <div class="col-md-6 col-xs-12 col-sm-12 expense">
                <div class="row">
                    <span>Honoraires</span>
                    <span class="pull-right data-display" :data-value="formattedInfos.honoraires">{{formattedInfos.honoraires}}</span>
                    <sup>€</sup>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	export default {
		name: 'bilanDashboard',
		props: {
			info : Object,
			showByDefault : Boolean,
			counterUp : Boolean
		},
		data () {
			return {
				formattedInfos:{},
				display:false
			}
		},
		mounted: function () {
			if(this.showByDefault){
				this.show()
			}
		},
		methods:{
			show:function(){
				this.$nextTick(() => {//wait for this.info to update
					for (let [key, value] of Object.entries(this.info)) {
					  this.formattedInfos[key]=parseFloat(value).toLocaleString(undefined,{'minimumFractionDigits':2,'maximumFractionDigits':2})
					}
					this.display=true
					this.startCounterUp()
				});	
			},
			startCounterUp:function(){//warning : counterUp use "," as thousand speparator and may display bigger number than target number during count-up
				if(this.counterUp){
					this.$nextTick(() => {//wait for DOM to update
						$(".data-display").counterUp();
					})
				}
			}
		}
	}
</script>
<style type="text/css">
	#result{
		margin: 2em 0;
	}
	#result sup{
		font-size: 14px
	}
	#result>div{
		box-shadow: 7px 9px 28px 1px rgba(0,0,0,0.15);
	}
	#bilanTableHeader{
		background-color: #70a6b285;
		display: flex;
		align-items: center;
		padding: 1em;
		border-top-right-radius: 3px!important;
		border-top-left-radius: 3px!important;
	}
	#bilanTableHeader span:first-child{
		font-size: 2.5rem;
		color: #444
	}
	#bilanTableHeader span:nth-child(2){
		font-size: 200%;
		text-align: right;
       	flex-grow: 1;
	}
	.profit div:nth-child(even){
		background-color: #6cb18285;
	}
	.profit div:nth-child(odd){
		background-color: #468b5c85;
	}
	.expense div:nth-child(even){
		background-color: #c9857085;
	}
	.expense div:nth-child(odd){
		background-color: #e3917985; 
	}
	#bilanTable>div>div{
		padding: 1em;
		display: flex;
		align-items: center;
	}
	#bilanTable>div>div span:first-child{
		font-size: 18px;
		color: #555
	}
	#bilanTable>div>div span:nth-child(2){
		font-size: 27px;
		text-align: right;
        flex-grow: 1;
	}
	.profit div:last-child{
		border-bottom-left-radius: 3px !important
	}
	.expense div:last-child{
		border-bottom-right-radius: 3px !important
	}
	@media(max-width: 767px){
		#bilanTableHeader span:first-child{
			font-size: 2rem;
		}
		#bilanTableHeader span:nth-child(2){
			font-size: 150%;
		}
		#bilanTable>div>div span:first-child{
			font-size: 15px;
		}
		#bilanTable>div>div span:nth-child(2){
			font-size: 20px;
		}
	}
</style>